import { useNavigate } from 'react-router-dom';
import { OnboardingHeader } from '@/features/onboarding/OnboardingHeader';
import { PayrollSetupSection } from '@/features/onboarding/sections/PayrollSetupSection';
import { OnboardingProvider } from '@/contexts/OnboardingContext';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useOnboarding } from '@/contexts/OnboardingContext';

const PayrollContent = () => {
  const { goToSection } = useOnboarding();

  useEffect(() => {
    // Navigate to payroll section (section 4)
    goToSection(4);
  }, [goToSection]);

  return <PayrollSetupSection />;
};

export const OnboardingPayroll = () => {
  return (
    <OnboardingProvider>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent/5">
        <OnboardingHeader />
        <div className="container mx-auto px-4 py-8 max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <PayrollContent />
          </motion.div>
        </div>
      </div>
    </OnboardingProvider>
  );
};

